import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-remove\"><path d=\"M1 15.77v-14H0v-1h4V0h6v.77h4v1h-1v14H1Zm1-1h10v-13H2v13Zm2.808-2h1v-9h-1v9Zm3.384 0h1v-9h-1v9Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol